<template>
  <div class="cl-inner">
    <!-- 搜索 -->
    <div class="search-inner">
      <a-form layout="inline">
        <a-form-item class="name" label="学生名称">
          <a-input
            class="form-cell"
            type="text"
            placeholder="请输入"
            v-model="queryParam.studentName"
          ></a-input>
        </a-form-item>
        <!-- <a-form-item class="name" label="家长昵称">
          <a-input
            class="form-cell"
            type="text"
            placeholder="请输入"
            v-model="queryParam.nickname"
          ></a-input>
        </a-form-item>
        <a-form-item class="name" label="家长电话">
          <a-input
            class="form-cell"
            type="text"
            placeholder="请输入"
            v-model="queryParam.mobile"
          ></a-input>
        </a-form-item> -->
        <a-form-item class="name" label="学号">
          <a-input
            class="form-cell"
            type="text"
            placeholder="请输入"
            v-model="queryParam.studentNumber"
          ></a-input>
        </a-form-item>
        <a-form-item label="年级">
          <a-select
            class="form-cell"
            placeholder="请选择"
            v-model="queryParam.gradeId"
            @change="changeGrade"
          >
            <a-select-option v-for="(item,index) in schoolGradeList" :key="index" :value="item.gradeTagId">
              {{ item.gradeName }}
            </a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item class="name" label="班级">
          <a-select
            class="form-cell"
            placeholder="请选择"
            v-model="queryParam.classId"
            @change="$forceUpdate()"
          >
            <a-select-option
              v-for="(item, index) in classList"
              :key="index"
              :value="item.id"
              >{{ item.className }}</a-select-option
            >
          </a-select>
        </a-form-item>
        <a-form-item label="性别">
          <a-select
            class="form-cell"
            placeholder="请选择"
            v-model="queryParam.gender"
          >
            <a-select-option
              v-for="(item, index) in $store.getters.gender"
              :key="index"
              :value="item.value"
              >{{ item.code }}</a-select-option
            >
          </a-select>
        </a-form-item>
        

        <!-- 学校 -->
        <c-school-select
          :schoolCode.sync="queryParam.schoolId"
        ></c-school-select>

        <a-form-item label="创建时间">
          <a-range-picker
            :value="times"
            format="YYYY-MM-DD HH:mm:ss"
            :showTime="{ defaultValue: [moment('00:00:00', 'HH:mm:ss'), moment('23:59:59', 'HH:mm:ss')] }"
            @change="onChange"
          />
        </a-form-item>
        <a-form-item class="search-oper">
          <a-button type="primary" @click="searchStudent()">查询</a-button>
          <a-button @click="resetQueryParams">重置</a-button>
        </a-form-item>
      </a-form>
    </div>

    <!-- 操作 -->
    <div class="list-oper">
      <a-button
        type="primary"
        icon="plus"
        @click="$refs.studentForm.init('add')"
        >新建</a-button
      >
      <a-button
        v-if="roleId == '3'"
        class="import-excel"
        type="primary"
        icon="plus"
        @click="$refs.studentFile.init()"
        >导入学生</a-button
      >
      <a-button
        v-if="openAllIndex == '0'"
        class="import-excel"
        type="primary"
        @click="openAllIndex = '2'"
        >批量归档</a-button
      >
      <a-button
        type="primary"
        class="select-row"
        v-if="openAllIndex == '0'"
        @click="openAllIndex = '1'"
        >批量删除</a-button
      >
      <template v-if="openAllIndex == '1'">
        <a-button type="primary" class="select-row" @click="deleteSelectRow()"
          >删除</a-button
        >
        <a-button type="primary" class="select-row" @click="openAllIndex = '0'"
          >取消</a-button
        >
      </template>
      <template v-if="openAllIndex == '2'">
        <a-button type="primary" class="select-row" @click="archivingSelectRow()"
          >归档</a-button
        >
        <a-button type="primary" class="select-row" @click="openAllIndex = '0'"
          >取消</a-button
        >
      </template>
      <div class="import-excel">
        <a class="download hover-font-active" @click="exportStudent"
          >导出学生报班</a
        >
      </div>
      <a-modal
        :centered="true"
        :closable="false"
        v-model="exportStudentVisible"
        @ok="exportOk"
      >
        <br />
        <br />
        <br />
        <span>请选择导出学期：</span>
        <a-select placeholder="请选择" v-model="term" style="width: 230px">
          <a-select-option
            :value="item.id"
            v-for="item in termList"
            :key="item.id"
          >
            {{ item.termName }}
          </a-select-option></a-select
        >
        <br />
        <br />
        <br />
      </a-modal>
      <div class="import-excel">
        <a class="download hover-font-active" @click="exportAllStudent"
          >导出全体学生信息</a
        >
      </div>
      <a-modal
        :centered="true"
        :closable="false"
        v-model="exportAllStudentVisible"
        @ok="exportAllOk"
      >
        <br />
        <br />
        <br />
        <span>请选择导出学期：</span>
        <a-select placeholder="请选择" v-model="term" style="width: 230px">
          <a-select-option
            :value="item.id"
            v-for="item in termList"
            :key="item.id"
          >
            {{ item.termName }}
          </a-select-option></a-select
        >
        <br />
        <br />
        <br />
      </a-modal>
      <div class="import-excel">
        <a
          class="download hover-font-active"
          @click="$refs.studentArchive.archiveStudent()"
          >查看归档学生</a
        >
      </div>
      <div class="import-excel" v-if="isShowHSdirectory">
        <a
          @click="HSdirectory"
          class="download hover-font-active"
          :title="HSdirectoryTitle"
          >同步家校通讯录</a
        >
      </div>
    </div>
    <!-- 表格数据 -->
    <a-table
      :columns="columns"
      :dataSource="studentList"
      class="c-table"
      :pagination="pagination"
      :loading="loading"
      @change="tableChange"
      :rowKey="getRowKey"
      :rowSelection="openAllIndex != '0' ? rowSelection : null"
    >
      <span slot="gender" slot-scope="text, record">
        <template>
          <span>{{
            record.gender == 0
              ? '未知'
              : record.gender == 1
              ? '男'
              : record.gender == 2
              ? '女'
              : ''
          }}</span>
        </template>
      </span>
      <span slot="gradeId" slot-scope="text, record">
        <template>
          <span>{{ record.gradeId | gradeScopeFilter }}</span>
        </template>
      </span>
      <span slot="bindParents" slot-scope="text, record">
        <template>
          <a-popover placement="rightTop" v-if="record.bindParents == '是'">
            <template #content>
              <p v-for="(item, index) in record.teaParents" :key="index">
                <showMobile :id="item.id" :nickName="item.nickName" :mobile="item.mobile"></showMobile>
                <a
                  @click="unbind(item, record)"
                  style="text-decoration: underline;margin-right:10px"
                  >解绑</a
                >
              </p>
            </template>
            <span
              >{{ record.bindParents
              }}<a-icon style="margin-left: 3px" type="search"
            /></span>
          </a-popover>
          <span v-else>{{ record.bindParents }}</span>
        </template>
      </span>
      <span slot="action" slot-scope="text, record">
        <template>
          <a @click="$refs.studentDetail.init(record)">查看所报班级</a>
          <a-divider type="vertical" />
          <a @click="$refs.studentForm.init('update', record)">修改</a>
        </template>
      </span>
    </a-table>

    <student-detail-modal ref="studentDetail"></student-detail-modal>

    <student-form-modal
      ref="studentForm"
      @addStudent="searchStudent"
      @editStudent="editStudent"
    ></student-form-modal>

    <student-file-modal
      ref="studentFile"
      @refreshList="searchStudent()"
    ></student-file-modal>
    <student-archive ref="studentArchive"></student-archive>
  </div>
</template>
<script>
import student from '../../api/student'

import term from '../../api/term'

import StudentFormModal from './StudentFormModal'

import StudentArchive from './StudentArchive'

import StudentFileModal from './components/StudentFileModal'

import StudentDetailModal from './components/StudentDetailModal'

import sourceClass from '../../api/sourceClass'

import school from '../../api/school'

import CSchoolSelect from '../../components/CSchoolSelect'

import showMobile from '../../components/showMobile/showMobile'
import moment from 'moment'
import Vue from 'vue'
const columns = [
  {
    title: 'ID',
    dataIndex: 'id',
    width: 70,
  },
  {
    title: '学生名称',
    dataIndex: 'studentName',
    width: 120,
  },
  {
    title: '性别',
    dataIndex: 'gender',
    scopedSlots: { customRender: 'gender' },
    width: 60,
  },
  {
    title: '生日',
    dataIndex: 'birthday',
  },
  {
    title: '学号',
    dataIndex: 'studentNumber',
  },
  {
    title: '原始班级',
    dataIndex: 'className',
  },
  {
    title: '年级',
    dataIndex: 'gradeId',
    scopedSlots: { customRender: 'gradeId' },
    width: 80,
  },
  {
    title: '学校名称',
    dataIndex: 'schoolName',
  },
  {
    title: '家长',
    dataIndex: 'bindParents',
    scopedSlots: { customRender: 'bindParents' },
  },
  // {
  //   title: '家长昵称',
  //   dataIndex: 'nickname',
  // },
  // {
  //   title: '家长电话',
  //   dataIndex: 'mobile',
  // },
  {
    title: '创建时间',
    dataIndex: 'gmtCreate',
    sorter: true,
  },
  {
    title: '操作',
    dataIndex: 'action',
    scopedSlots: { customRender: 'action' },
  },
]

export default {
  name: 'studentList',
  data() {
    return {
      moment,
      studentList: [], //学生数据
      columns, //列标识数据
      queryParam: {}, //查询参数
      pagination: {
        pageSize: 10,
        total: 0,
        showTotal: (total) => `总共 ${total} 条`, // 显示总数
        showSizeChanger: true,
        pageSizeOptions: ['10', '20', '30', '50', '70', '100'],
        current: 1,
        currentPage: 1,
      }, //分页数据对象
      loading: true,
      times: [],
      classList: [], //班级列表
      classListAll:[],
      roleId: -1, //角色id
      openAllIndex: '0', //是否开启全部选择
      selectedRowKeys: [], //table选中的项目list
      exportStudentVisible: false, //导出学生报班弹框状态
      exportAllStudentVisible: false, //导出全体学生报班弹框状态
      termList: [], //学期列表
      term: '', //学期id
      isShowHSdirectory: false,
      HSdirectoryTitle: '',
      HSdirectoryStatus: '',
      schoolGradeList:[],
      studentIds:[]
    }
  },
  computed: {
    rowSelection() {
      const { selectedRowKeys } = this
      return {
        selectedRowKeys,
        onChange: (selectedRowKeys) => {
          this.selectedRowKeys = selectedRowKeys
          this.studentIds = selectedRowKeys.map(item => {
            return this.studentList.find((ele,index) => index == item).id
          })
          // console.log(this.studentIds)
        },
      }
    },
  },
  components: {
    StudentFormModal,
    CSchoolSelect,
    StudentDetailModal,
    StudentFileModal,
    StudentArchive,
    showMobile
  },
  methods: {
    changeGrade(key){
      if (this.queryParam.classId) this.queryParam.classId = null
      this.classList = this.classListAll.filter(item => item.gradeId == key)
    },
    //解除绑定
    unbind(item, record) {
      let data = {
        studentId: item.id,
        mobile: item.mobile,
        nickName: item.nickName,
      }
      let _this = this
      this.$confirm({
        content: `确定解绑家长${item.nickName}和学生${record.studentName}的绑定关系吗？`,
        onOk() {
          student.unbindRelation(data).then((res) => {
            _this.$message.success('解绑成功')
            _this.getStudentList(_this.queryParam)
          })
        },
        onCancel() {},
      })
    },
    showHSdirectory() {
      student
        .showHSdirectory({ schoolId: Vue.ls.get('schoolId') })
        .then((res) => {
          if (res.code == 0) {
            this.isShowHSdirectory = true
            if (res.data.status == 0) {
              this.HSdirectoryTitle = '同步未开始'
            } else if (res.data.status == 1) {
              this.HSdirectoryTitle = `上次导入时间：${moment(
                res.data.createTime
              ).format('YYYY-MM-DD HH:mm:ss')} ; 状态：已完成 ; 新增班级${
                res.data.classCountNew
              }个 , 同步班级${res.data.classCountExists}个 , 新增学员${
                res.data.studentCountNew
              }个 , 同步学生${res.data.studentCountExists}个 。`
            } else if (res.data.status == 2) {
              this.HSdirectoryTitle = `上次导入时间：${moment(
                res.data.createTime
              ).format('YYYY-MM-DD HH:mm:ss')} ; 状态：同步中 ; 异常：${
                res.data.logText
              } ; 新增班级${res.data.classCountNew}个 , 同步班级${
                res.data.classCountExists
              }个 , 新增学员${res.data.studentCountNew}个 , 同步学生${
                res.data.studentCountExists
              }个。 `
            } else if (res.data.status == 3) {
              this.HSdirectoryTitle = `上次导入时间：${moment(
                res.data.createTime
              ).format('YYYY-MM-DD HH:mm:ss')} ; 状态：异常终止 ; 异常：${
                res.data.logText
              } ; 新增班级${res.data.classCountNew}个 , 同步班级${
                res.data.classCountExists
              }个 , 新增学员${res.data.studentCountNew}个 , 同步学生${
                res.data.studentCountExists
              }个 。`
            }
          }
        })
    },
    HSdirectory() {
      student.HSdirectory({ schoolId: Vue.ls.get('schoolId') }).then((res) => {
        this.showHSdirectory()
      })
    },
    //获取学期列表
    getTermList_all() {
      term.getTermList_all().then((res) => {
        this.termList = res.data
      })
    },
    //导出学生报班
    exportOk() {
      let _this = this
      this.$confirm({
        title: '注意',
        okText: '确定',
        cancelText: '取消',
        icon:'exclamation-circle',
        content: '注意：仅支持导出1万条数据记录，如需导出更多数据请提出人工导出申请',
        onOk() {
          _this.$message.success('导出中...')
      student
        .exportApplyStudent({ ..._this.queryParam, termId: _this.term })
        .then((res) => {
          console.log(res,'export')
          const url = window.URL.createObjectURL(res.data) //URL.createObjectURL(object)表示生成一个File对象或Blob对象
          let dom = document.createElement('a') //设置一个隐藏的a标签，href为输出流，设置download
          dom.style.display = 'none'
          dom.href = url
          dom.setAttribute('download', '学生报班.xlsx')
          document.body.appendChild(dom)
          dom.click()
          _this.exportStudentVisible = false
        })
        },
      })
    },
    //导出全体学生
    exportAllOk() {
      let _this = this
      this.$confirm({
        title: '注意',
        okText: '确定',
        cancelText: '取消',
        icon:'exclamation-circle',
        content: '注意：仅支持导出1万条数据记录，如需导出更多数据请提出人工导出申请',
        onOk() {
          _this.$message.success('导出中...')
      student
        .exportAllStudent({
          termId: _this.term,
          schoolId: Vue.ls.get('schoolId'),
        })
        .then((res) => {
          console.log(res,'expor111')
          const url = window.URL.createObjectURL(res.data) //URL.createObjectURL(object)表示生成一个File对象或Blob对象
          let dom = document.createElement('a') //设置一个隐藏的a标签，href为输出流，设置download
          dom.style.display = 'none'
          dom.href = url
          dom.setAttribute('download', '全体学生信息.xlsx')
          document.body.appendChild(dom)
          dom.click()
          _this.exportAllStudentVisible = false
        })
        },
      })
    },
    resetQueryParams() {
      this.queryParam = {}
      this.times = []
      this.classList = this.classListAll
    },
    onChange(date) {
      this.times = date
      if (!date.length) {
        this.queryParam = {}
        return
      }
      this.queryParam.startTime = moment(date[0]).format('YYYY-MM-DD HH:mm:ss')
      this.queryParam.endTime = moment(date[1]).format('YYYY-MM-DD HH:mm:ss')
    },
    // 表格删除选中的学生
    deleteSelectRow() {
      if (this.selectedRowKeys.length == 0) {
        this.$message.error('请勾选删除项')
        return
      }
      console.log(this.selectedRowKeys,this.queryParam)
      student.batchDelete({ ids: this.studentIds.join() }).then((res) => {
        this.$message.success('删除成功')
        this.getStudentList(this.queryParam)
        this.selectedRowKeys = []
        this.studentIds = []
      })
    },
        // 表格归档选中的学生
      archivingSelectRow() {
      if (this.selectedRowKeys.length == 0) {
        this.$message.error('请勾选归档项')
        return
      }
      student.batchArchiving({ ids: this.studentIds.join() }).then((res) => {
        this.$message.success('归档成功')
        // this.searchStudent()
        this.getStudentList(this.queryParam)
        this.selectedRowKeys = []
        this.studentIds = []
      })
    },
    getRowKey(record, index) {
      return index;
    },
    //导出学生
    exportStudent(e) {
      this.exportStudentVisible = true
    },
    //导出全体学生信息
    exportAllStudent() {
      this.exportAllStudentVisible = true
    },

    //table发生该表，分页，排序
    tableChange(pagination, filters, sorter) {
      //如果查询有地址的话，把地址解析之后带入
      let obj = this.queryParam
      obj.currentPage = pagination.current
      obj.current = pagination.current
      obj.pageSize = pagination.pageSize
      this.pagination.current = pagination.currentPage
      this.pagination.pageSize = pagination.pageSize
      this.selectedRowKeys = []
      //存在排序的时候
      if (sorter && sorter.columnKey) {
        obj.sorter = `${sorter.columnKey}-${
          sorter.order == 'ascend' ? 'asc' : 'desc'
        }`
      }
      console.log('obj', obj)
      window.location.hash = `#${this.$route.path}?params=${JSON.stringify(
        obj
      )}`
      // console.log('obj', obj)
      this.getStudentList(obj)
    },

    // 修改某个学生
    editStudent(){
      // const cur = this.studentList.findIndex(i => i.id == student.id)
      // if (cur != -1) Object.assign(this.studentList[cur], student)
      this.getStudentList(this.queryParam)
    },

    //查询学生
    searchStudent() {
      this.queryParam.currentPage = 1
      window.location.hash = `#${this.$route.path}?params=${JSON.stringify(
        this.queryParam
      )}`
      this.getStudentList(this.queryParam)
    },

    //学生列表
    getStudentList(params) {
      // console.log('params', params)
      this.pagination.currentPage = params.currentPage
      this.pagination.current = params.currentPage
      this.loading = true
      student.getStudentList(params).then((res) => {
        // console.log('当前的学生列表是', res.data.list)
        const total = res.data.pagination.total
        this.studentList = res.data.list.map((item) => {
          if (item.teaParents) {
            item.teaParents = item.teaParents.split('\r\n')
            item.teaParents = item.teaParents.map(i => {
              return {
                id: item.id,
                nickName: i.split('\t')[0],
                mobile: i.split('\t')[1],
              }
            })
          }
          if (item.parentCount == 0) {
            return { ...item, bindParents: '否' }
          } else if (item.parentCount != 0) {
            return { ...item, bindParents: '是' }
          } else {
            return item
          }
        })
        this.loading = false
        //平台角色特殊处理
        // if (this.roleId == "6") {
        //   res.data.pagination.total = res.data.pagination.total + 400000;
        // }
        //分页信息
        this.pagination.total = total
        this.pagination.current = res.data.pagination.current
        if (total > 10000 && !this.pagination.pageSizeOptions.includes('120')) {
          this.pagination.pageSizeOptions = [
            ...this.pagination.pageSizeOptions,
            '120',
            '150',
          ]
        }
        if (
          res.data.pagination.total > 100000 &&
          !this.pagination.pageSizeOptions.includes('200')
        ) {
          this.pagination.pageSizeOptions.push('200')
        }
      })
      // console.log('this.paginationafter', this.pagination)
    },

    //是否有操作权限
    judgeIsOper() {
      this.$store.dispatch('getUserInfo').then(async (res) => {
        this.roleId = res.accRole.id.toString()
        if (this.roleId == '6' && !this.$route.query.params) {
          await school.searchSchool({ schoolName: '' }).then((res) => {
            this.queryParam.schoolId = res.data[0].id
          })
        }
        this.getStudentList({ ...this.pagination, ...this.queryParam })
      })
    },

    init() {
      //下拉班级列表
      sourceClass.selectSearch().then((res) => {
        this.classList = res.data
        this.classListAll = res.data
        //是否有跳转，跳转带值查询
        if (this.$route.params.classId) {
          this.$set(this.queryParam, 'classId', this.$route.params.classId)
        }
        if (this.$route.params.mobile) {
          this.$set(this.queryParam, 'mobile', this.$route.params.mobile)
        }
        this.judgeIsOper()
        this.getTermList_all()
      })
    },
  },
  created() {
    if (this.$route.query.params) {
      this.queryParam = JSON.parse(this.$route.query.params)
    } else {
      this.queryParam = {}
    }
    this.schoolGradeList = Vue.ls.get('schoolGrade')
    this.init()
    this.$store.dispatch('getUserInfo').then((res) => {
      this.roleId = res.accRole.id.toString()
      // console.log('this', this.roleId)
      //平台管理员
      // if (this.roleId != '6') {
      //   this.showHSdirectory()
      // }
    })
  },
}
</script>
<style lang="scss" scoped>
@import 'src/config/var';
.cl-inner {
  width: calc(100% - 40px);
  padding: 20px;
  background: white;
  margin: 20px auto;
}
.search-oper {
  button {
    margin: 0px 5px;
  }
}
.list-oper {
  margin: 20px 0px 30px;
}
.price-scope {
  width: 100px;
  text-align: center;
}
.max-price {
  border-left: none;
}
.price-gap {
  width: 30px;
  border-left: 0;
  pointer-events: none;
  background: #fff;
}
.import-excel {
  display: inline-block;
  margin-left: 20px;
  position: relative;
  input {
    position: absolute;
    top: 0px;
    left: 0px;
    width: 110px;
    height: 32px;
    z-index: 999;
    opacity: 0;
  }
  .download {
    display: inline-block;
    margin-left: 20px;
    text-decoration: underline;
    color: $primary-color-dark;
    position: relative;
    z-index: 1000;
  }
}
</style>
